/* eslint-disable yoda */
/* eslint-disable quote-props */
import { getCloudinaryTextData } from 'shared-components/inputs/data/cloudinary-data';

const CLOUDINARY_CLOUD_NAME = 'peerspace-inc';

export function getSpacePhotoPresets (intl) {
  return {
    upload_preset: 'e6m9x7iz',
    client_allowed_formats: ['jpg', 'jpeg', 'png'],
    show_powered_by: false,
    multiple: true,
    sources: ['local'],
    theme: 'minimal',
    max_file_size: 8000000,
    max_image_width: 4000,
    max_image_height: 4000,
    max_files: 40,
    language: 'en',
    text: {
      'en': getCloudinaryTextData(intl)
    }
  };
}

/**
 * Opens the Cloudinary widget and returns a single Promise that resolves
 * with an array of ALL uploaded file info objects.
 * This version uses the legacy primary callback ONLY (no .on() listeners).
 */
export const openCloudinaryWidget = (intl) => {
  return new Promise((resolve, reject) => {
    if (typeof window.cloudinary === 'undefined') {
      return reject(new Error('Cloudinary widget library is not loaded.'));
    }

    const presetHash = getSpacePhotoPresets(intl);
    const uploadedFiles = [];
    let resolved = false;

    const uploadWidget = window.cloudinary.createUploadWidget(
      { cloud_name: CLOUDINARY_CLOUD_NAME, ...presetHash },

      (error, result) => {
        if (resolved) return;

        if (error) {
          resolved = true;
          uploadWidget.close();
          return reject(error);
        }

        if (result.event === 'success') {
          uploadedFiles.push(result.info);
          return;
        }

        if (result.event === 'close' || result.event === 'abort') {
          resolved = true;
          uploadWidget.close();

          if (uploadedFiles.length > 0) {
            resolve(uploadedFiles);
          } else {
            reject(new Error('Upload cancelled by user.'));
          }
        }
      }
    );

    uploadWidget.open();
  });
};
